<template>
  <div>
    <check-selector-collapse
      :icon="icon"
      :label="label"
      :options="options"
      @checked="handleChecked"
    />
  </div>
</template>

<script>
import CheckSelectorCollapse from '../../../../commons/forms/CheckSelectorCollapse.vue';
import catalogoSellout from '@/api/catalogoSellout.api';
import { mapActions } from 'vuex';
import { mapState } from 'vuex';

export default {
  name: 'SubfamiliasSelector',
  components: { CheckSelectorCollapse },
  extends: catalogoSellout,
  props: {
    label: {
      type: String,
      default: 'Subfamilias',
    },
    icon: {
      type: String,
      default: 'icon-pharmacy',
    },
  },
  data() {
    return {
      options: [],
      selectedItems: [],
      selectedItemsSet: new Set(),
    };
  },
  computed: {
    ...mapState('filters', ['filtros']),
  },
  watch: {
    'filtros.subfamilias': function (newFiltros) {
      this.syncSelectedItemsWithStore(newFiltros);
    },
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    loadItems() {
      let loadPromise = new Promise((resolve) => {
        this.getSubfamilias(resolve, this.request);
      });

      loadPromise.then((data) => {
        this.options = data.map((item) => ({
          text: item.subfamilia,
          value: item.id_subfamilia,
          selected: false,
        }));
      });
    },
    syncSelectedItemsWithStore() {
      const subfamiliasSeleccionados = this.filtros.subfamilias || [];

      const selectedItemsSet = new Set();

      subfamiliasSeleccionados.forEach((subfamilia) => {
        selectedItemsSet.add(String(subfamilia.codigo));
        selectedItemsSet.add(String(subfamilia.value));
      });

      this.options = this.options.map((item) => {
        item.selected = selectedItemsSet.has(String(item.value));
        return item;
      });
    },
    handleChecked(newSelectedItems) {
      const subfamiliasSeleccionadas = this.filtros.subfamilias || [];

      if (!Array.isArray(newSelectedItems)) {
        newSelectedItems = [newSelectedItems];
      }

      newSelectedItems.forEach((selected) => {
        const valueToCheck = String(selected.value);

        if (selected.selected) {
          this.selectedItemsSet.add(valueToCheck);
        } else {
          this.selectedItemsSet.delete(valueToCheck);
        }
      });

      let selectedItemsArray = Array.from(this.selectedItemsSet);

      subfamiliasSeleccionadas.forEach((item) => {
        const valueToCheck = item.value
          ? String(item.value)
          : String(item.codigo);

        if (!selectedItemsArray.includes(valueToCheck)) {
          selectedItemsArray.push(valueToCheck);
        }
      });

      newSelectedItems.forEach((selected) => {
        if (!selected.selected) {
          const valueToCheck = String(selected.value);
          selectedItemsArray = selectedItemsArray.filter(
            (item) => item !== valueToCheck
          );
        }
      });

      const selectedItems = selectedItemsArray.map((value) => ({
        value,
        selected: true,
      }));

      this.updateFiltros({
        filtro: 'subfamilias',
        items: selectedItems,
      });
    },
    ...mapActions('filters', ['updateFiltros']),
  },
};
</script>
